import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Preloader = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Lock scroll during intro
    document.body.style.overflow = "hidden";
    
    // Total duration before hiding preloader
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Wait for exit animation to complete before restoring scroll
      setTimeout(() => {
        document.body.style.overflow = "auto";
      }, 1000); 
    }, 2800); // Wait for scale and progress to finish

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
           initial={{ y: 0 }}
           exit={{ y: "-100vh" }} // Slider scrolls up like before
           transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
           className="fixed inset-0 z-[99999] bg-[#F9F8F5] flex items-center justify-center pointer-events-none"
        >
          {/* Ambient Glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#835F21]/5 rounded-full blur-[120px] pointer-events-none" />
          
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }} // Scales from small to big, but not too big
            transition={{ duration: 1.5, ease: [0.76, 0, 0.24, 1] }}
            className="relative z-10 flex flex-col items-center justify-center w-full"
          >
            {/* Logo Mark */}
            <div className="drop-shadow-lg mb-8">
              <img src="/logo.png" alt="ATF Logo" className="w-[180px] md:w-[220px] object-contain" />
            </div>

            {/* Progress Bar Container */}
            <div className="w-[200px] h-[2px] bg-[#141414]/10 relative overflow-hidden rounded-full mb-8">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ duration: 1.8, delay: 0.4, ease: [0.76, 0, 0.24, 1] }}
                className="absolute top-0 left-0 h-full bg-[#835F21]"
              />
            </div>

            {/* Status text */}
            <motion.div 
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="flex flex-col items-center gap-4"
            >
              <div className="flex items-center gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-[#835F21] animate-pulse shadow-[0_0_10px_rgba(131,95,33,0.4)]" />
                <p className="font-sans text-[10px] tracking-[0.4em] text-[#141414]/70 uppercase font-bold">
                  Initializing Protocol
                </p>
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
